import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { Grid, IconButton } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemButton from '@mui/material/ListItemButton';
import Typography from '@mui/material/Typography';
import { useState } from 'react';

const Facebook = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="24"
      height="24"
      viewBox="0 0 50 50"
    >
      <path d="M 30.140625 2 C 26.870375 2 24.045399 2.9969388 22.0625 4.9667969 C 20.079601 6.936655 19 9.823825 19 13.367188 L 19 18 L 13 18 A 1.0001 1.0001 0 0 0 12 19 L 12 27 A 1.0001 1.0001 0 0 0 13 28 L 19 28 L 19 47 A 1.0001 1.0001 0 0 0 20 48 L 28 48 A 1.0001 1.0001 0 0 0 29 47 L 29 28 L 36 28 A 1.0001 1.0001 0 0 0 36.992188 27.125 L 37.992188 19.125 A 1.0001 1.0001 0 0 0 37 18 L 29 18 L 29 14 C 29 12.883334 29.883334 12 31 12 L 37 12 A 1.0001 1.0001 0 0 0 38 11 L 38 3.3457031 A 1.0001 1.0001 0 0 0 37.130859 2.3554688 C 36.247185 2.2382213 33.057174 2 30.140625 2 z M 30.140625 4 C 32.578477 4 34.935105 4.195047 36 4.2949219 L 36 10 L 31 10 C 28.802666 10 27 11.802666 27 14 L 27 19 A 1.0001 1.0001 0 0 0 28 20 L 35.867188 20 L 35.117188 26 L 28 26 A 1.0001 1.0001 0 0 0 27 27 L 27 46 L 21 46 L 21 27 A 1.0001 1.0001 0 0 0 20 26 L 14 26 L 14 20 L 20 20 A 1.0001 1.0001 0 0 0 21 19 L 21 13.367188 C 21 10.22255 21.920305 7.9269075 23.472656 6.3847656 C 25.025007 4.8426237 27.269875 4 30.140625 4 z"></path>
    </svg>
  );
};
const XIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24px"
      height="24px"
      viewBox="0 0 35 35"
    >
      <path d="M 4.0175781 4 L 13.091797 17.609375 L 4.3359375 28 L 6.9511719 28 L 14.246094 19.34375 L 20.017578 28 L 20.552734 28 L 28.015625 28 L 18.712891 14.042969 L 27.175781 4 L 24.560547 4 L 17.558594 12.310547 L 12.017578 4 L 4.0175781 4 z M 7.7558594 6 L 10.947266 6 L 24.279297 26 L 21.087891 26 L 7.7558594 6 z"></path>
    </svg>
  );
};
const Email = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 31 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
    >
      <rect y="0.5" width="31" height="31" fill="url(#pattern0)" />
      <defs>
        <pattern
          id="pattern0"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use href="#image0_26879_27772" transform="scale(0.00195312)" />
        </pattern>
        <image
          id="image0_26879_27772"
          width="512"
          height="512"
          href="data:image/png;base64,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"
        />
      </defs>
    </svg>
  );
};
const Copy = () => {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.7285 3.88396C17.1629 2.44407 19.2609 2.41383 20.4224 3.57981C21.586 4.74798 21.5547 6.85922 20.1194 8.30009L17.6956 10.7333C17.4033 11.0268 17.4042 11.5017 17.6976 11.794C17.9911 12.0863 18.466 12.0854 18.7583 11.7919L21.1821 9.35869C23.0934 7.43998 23.3334 4.37665 21.4851 2.5212C19.6346 0.663551 16.5781 0.905664 14.6658 2.82536L9.81817 7.69182C7.90688 9.61053 7.66692 12.6739 9.51519 14.5293C9.80751 14.8228 10.2824 14.8237 10.5758 14.5314C10.8693 14.2391 10.8702 13.7642 10.5779 13.4707C9.41425 12.3026 9.44559 10.1913 10.8809 8.75042L15.7285 3.88396Z"
        fill="#3d3b40"
      />
      <path
        d="M14.4851 9.47074C14.1928 9.17728 13.7179 9.17636 13.4244 9.46868C13.131 9.76101 13.1301 10.2359 13.4224 10.5293C14.586 11.6975 14.5547 13.8087 13.1194 15.2496L8.27178 20.1161C6.83745 21.556 4.73937 21.5863 3.57791 20.4203C2.41424 19.2521 2.44559 17.1408 3.88089 15.6999L6.30473 13.2667C6.59706 12.9732 6.59614 12.4984 6.30268 12.206C6.00922 11.9137 5.53434 11.9146 5.24202 12.2081L2.81818 14.6413C0.906876 16.5601 0.666916 19.6234 2.51519 21.4789C4.36567 23.3365 7.42221 23.0944 9.33449 21.1747L14.1821 16.3082C16.0934 14.3895 16.3334 11.3262 14.4851 9.47074Z"
        fill="#3d3b40"
      />
    </svg>
  );
};
const Download = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.25 6C1 5.25 1 4.5 1 3.97818C1 2.23909 2.55724 0.5 4.47818 0.5C5.7656 0.5 6.88965 1.19946 7.49105 2.23909H7.95636C9.39707 2.23909 10.75 3.25 10.75 4.5C10.75 5 10.75 5.5 10.5 6"
        stroke="url(#paint0_linear_668_108835)"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.70703 9.16577L5.7487 11.1249L7.79036 9.16577"
        stroke="url(#paint1_linear_668_108835)"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.75 10.6096L5.75 5.06248"
        stroke="url(#paint2_linear_668_108835)"
        stroke-linecap="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_668_108835"
          x1="5.875"
          y1="0.5"
          x2="5.875"
          y2="6"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#3d3b40" />
          <stop offset="1" stop-color="#3d3b40" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_668_108835"
          x1="3.70703"
          y1="10.1453"
          x2="7.79036"
          y2="10.1453"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#3d3b40" />
          <stop offset="1" stop-color="#3d3b40" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_668_108835"
          x1="5.75"
          y1="7.83605"
          x2="4.75"
          y2="7.83605"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#3d3b40" />
          <stop offset="1" stop-color="#3d3b40" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const listItems = [
  {
    name: 'Facebook',
    image: <Facebook width={24} height={24} />,
  },
  {
    name: 'Twitter',
    image: <XIcon width={24} height={24} />,
  },
  {
    name: 'Email',
    image: <Email width={24} height={24} />,
  },
  {
    name: 'Copy link',
    image: <Copy width={24} height={24} />,
  },
  {
    name: 'Download PDF',
    image: <Download width={24} height={24} />,
  },
];

export function SharePopup(props) {
  const { onClose, open } = props;
  const [clickedcopy, setclickedcopy] = useState(false);

  const handleClose = () => {
    onClose(onClose);
  };

  const handleListItemClick = (value) => {
    onClose(value);
  };

  var CopyUrl = window.location.href;
  var modifiedUrl = CopyUrl.replace('market', 'share');
  const facebook = `https://www.facebook.com/messages/new/`;
  const twitter = `https://twitter.com/messages/compose`;
  const Email = `https://mail.google.com/mail/?view=cm&body=${modifiedUrl}`;

  function copyToClipboard(text) {
    var inputc = document.body.appendChild(document.createElement('input'));
    inputc.value = window.location.href;
    inputc.focus();
    inputc.select();
    document.execCommand('copy');
    inputc.parentNode.removeChild(inputc);
    alert('URL Copied.');
  }

  return (
    <Dialog
      open={open}
      PaperProps={{
        sx: {
          borderRadius: '15px',
          height: '570px',
          width: '550px',
        },
      }}
    >
      <Grid sx={{ padding: '15px' }}>
        <Grid sx={{ display: 'flex', justifyContent: 'right' }}>
          <IconButton onClick={() => handleClose()}>
            <CloseOutlinedIcon width={34} height={34} />
          </IconButton>
        </Grid>
        <DialogTitle
          style={{
            fontSize: '25px',
            color: '#3D3B40',
            fontWeight: 700,
            marginTop: '-10px',
            fontFamily: 'poppins',
          }}
        >
          Share this listing
        </DialogTitle>
        <List sx={{ pt: 0 }}>
          {listItems.map((email) => (
            <ListItem
              disableGutters
              key={email}
              onClick={() => {
                navigator.clipboard.writeText(modifiedUrl);
                if (email?.name == 'Facebook') {
                  window.open(facebook, '_blank');
                } else if (email?.name == 'Twitter') {
                  window.open(twitter, '_blank');
                } else if (email?.name == 'Email') {
                  window.open(Email, '_blank');
                } else if (email?.name == 'Copy link') {
                  navigator.clipboard.writeText(modifiedUrl);
                  setclickedcopy(true);
                  setTimeout(() => {
                    setclickedcopy(false);
                    handleClose();
                  }, 700);
                }
              }}
            >
              <ListItemButton>
                <ListItemAvatar>
                  <Avatar
                    sx={{
                      bgcolor: '#f6f5f7',
                      color: '#3d3b40',
                      width: '50px',
                      height: '50px',
                    }}
                  >
                    {email.image}
                  </Avatar>
                </ListItemAvatar>
                <Grid container sx={{ justifyContent: 'space-between' }}>
                  <Typography
                    sx={{
                      fontSize: '1rem',
                      fontFamily: 'poppins',
                      lineHeight: '1.5rem',
                      fontWeight: 500,
                      color: '#00639e',
                      marginLeft: '10px',
                    }}
                  >
                    {email.name}
                  </Typography>
                  {clickedcopy && email.name == 'Copy link' && (
                    <Typography
                      sx={{
                        fontSize: '1rem',
                        fontFamily: 'poppins',
                        lineHeight: '1.5rem',
                        fontWeight: 500,
                        color: 'green',
                        marginLeft: '10px',
                      }}
                    >
                      Copied !
                    </Typography>
                  )}
                </Grid>
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Grid>
    </Dialog>
  );
}
